import { useState } from 'react';

export default () => {
  const [looping, setLooping] = useState(false);

  return {
    looping,
    setLooping,
  };
};
